registerComponent("modals/modal-faq", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Quem abre este modal é o `templates/header` (o botão de ajuda e o item
 * "Ajuda e suporte" do menu), o `templates/footer` e, desde 16/09 (ADR 0047),
 * o `templates/footer-redesign` em toda página. Em 2020 a conversa era
 * `$modalFaq.trigger('open')`; agora é um `CustomEvent('open')` no elemento —
 * emissor e ouvinte mudaram no mesmo sub-lote, porque um `.trigger()` do
 * jQuery e um `addEventListener` não se escutam.
 *
 * Abre TAMBÉM pelo ENDEREÇO, no fragmento que o Blade manda em `data-ancora`
 * (`#ajuda-e-suporte`, `#help-and-support` em inglês): na carga e a cada
 * `hashchange`, para um link de fora cair direto na central de ajuda. É o mesmo
 * contrato do `modals/abrir-conta`, e pela mesma razão — sair do fragmento (o
 * Voltar do navegador) fecha, e o fechamento tira o fragmento do endereço,
 * senão um F5 reabriria o que o visitante acabou de fechar. Os gatilhos
 * continuam `<button>`: quem clica não navega, só quem chega pelo endereço.
 *
 * A rolagem trava por `Asa.travarRolagem`, como no `modal-docs`: a regra de
 * `body.modal-opened` só existe sob `body.legado`, que as páginas do design
 * não têm. A classe continua, porque é ela que baixa o header de 2020.
 */

const TRAVA = 'modal-faq';

const btnClose = component.querySelector('.btn-close');
const iframe = component.querySelector('.iframe-faq');

/** O fragmento que abre o modal, sem o `#`. Vazio se o Blade não mandar. */
const ancora = component.dataset.ancora || '';

/** O endereço está na âncora do modal? */
const noEndereco = () => ancora !== '' && decodeURIComponent(window.location.hash).slice(1) === ancora;

/*
 | Tira o fragmento do endereço sem mexer na rolagem nem no histórico: o
 | `replaceState` não dispara `hashchange`, logo não reentra aqui. Sempre com o
 | `pathname` na frente, porque com o `<base href>` um caminho vazio resolveria
 | contra a raiz.
 */
const limparEndereco = () => {
    if (!noEndereco()) return;

    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
};

/* Tagueamento (plano v3.1): quem pediu o modal. O `open` chega sem origem, então
   o clique no botão que o abre é lido antes, na captura. */
let origem = 'deep_link';
let abertoEm = 0;

document.addEventListener('click', (event) => {
    const botao = event.target instanceof Element ? event.target.closest('[data-open-modal-faq]') : null;

    if (!botao) return;

    if (botao.closest('[data-component-name="templates/footer-redesign"]')) origem = 'footer';
    else origem = document.documentElement.classList.contains('js-menu-aberto') ? 'mobile_menu' : 'header';
}, true);

const abrir = (metodo = 'click') => {
    if (component.classList.contains('active')) return;

    abertoEm = Date.now();
    Asa.track('modal_open', { modal_name: 'faq', origin: metodo === 'hash' ? 'deep_link' : origem, method: metodo });

    /*
     | O IFRAME SÓ CARREGA AQUI. O markup traz o endereço em `data-src`: com
     | `src` no HTML o navegador baixava 1,44 MB de Genesys Cloud e New Relic em
     | toda página, na carga, porque `loading="lazy"` não vale para iframe que o
     | Chrome considera oculto — e este nasce `visibility: hidden` (PERF-001).
     */
    if (iframe && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframe.dataset.src);
    }

    document.body.classList.add('modal-opened');
    component.classList.add('active');
    Asa.travarRolagem(TRAVA);
};

const fechar = (metodo = 'x') => {
    if (!component.classList.contains('active')) return;

    Asa.track('modal_close', { modal_name: 'faq', method: metodo, seconds: Math.round((Date.now() - abertoEm) / 1000) });

    document.body.classList.remove('modal-opened');

    /*
     | Tirar o `src` devolve a central de ajuda à primeira tela ao fechar, que é
     | o comportamento de 2020 (lá o `src` era regravado), e ainda solta a
     | conexão e o WebSocket do widget. A próxima abertura o grava de novo a
     | partir do `data-src`.
     */
    if (iframe) {
        iframe.removeAttribute('src');
    }

    component.classList.remove('active');
    Asa.soltarRolagem(TRAVA);
    limparEndereco();
};

component.addEventListener('open', () => abrir('click'));

if (btnClose) {
    btnClose.addEventListener('click', () => fechar('x'));
}

window.addEventListener('hashchange', () => {
    if (noEndereco()) abrir('hash');
    else fechar('back_link');
});

if (noEndereco()) abrir('hash');

});
